import { Drawer } from "@/react/components/shared/ModalsV2/Drawer";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { useShowPreviewSnippet } from "../snippetsQueries";
import { Content } from "./Content";
import { Details } from "./Details";

export const PreviewSnippetDrawerComponent = ({ id }: { id: number }) => {
  const modal = useModal();
  const { data: snippet } = useShowPreviewSnippet({ id });

  return (
    <Drawer isOpen={Boolean(modal.visible)} onClose={modal.hide} size="xl">
      <Drawer.Body className="!p-0">
        <div className="flex h-full flex-row">
          <Content snippet={snippet} />
          <Details snippet={snippet} />
        </div>
      </Drawer.Body>
    </Drawer>
  );
};
